import * as React from "react";
import { forwardRef } from "react";
const SvgToolStackScroll = ({
  title,
  titleId,
  ...props
}, ref) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<g fill="none" fillRule="evenodd" stroke="currentColor" strokeWidth={1.5} transform="translate(1 1)"><rect width={14.286} height={14.286} y={5.714} rx={2} /><path strokeLinecap="round" d="M3.01 2.857h11.98c1.105 0 2 .896 2 2v12.286h0" /><path strokeLinecap="round" d="M5.714 0h11.982c1.104 0 2 .895 2 2v12.286h0" /></g></svg>;
const ForwardRef = forwardRef(SvgToolStackScroll);
export { ForwardRef as ReactComponent };